import './index.css'

const CardItem = props => {
  const {cardsDetails} = props
  const {title, description, imgUrl, className} = cardsDetails
  return (
    <li className={`licontainer ${className}`}>
      <div>
        <h1>{title}</h1>
        <p>{description}</p>
        <div className="image">
          <img src={imgUrl} alt={title} />
        </div>
      </div>
    </li>
  )
}

export default CardItem
